import React, { useId, useState, useEffect, useRef } from 'react';

/** Supporting build information stays expanded on desktop and discoverable on phones. */
export default function MobileDisclosure({ label, summary, children, id, icon, defaultOpen = false }: {
  label: string; summary?: string; children: React.ReactNode; id?: string;
  icon?: React.ReactNode; defaultOpen?: boolean;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();
  const rootRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const reveal = (event?: Event) => {
      const targetId = event ? (event as CustomEvent<string>).detail : window.location.hash.slice(1);
      const target = document.getElementById(targetId);
      if (target && rootRef.current?.contains(target)) setOpen(true);
    };
    reveal();
    const onHash = () => reveal();
    window.addEventListener('bilt-section-open', reveal);
    window.addEventListener('hashchange', onHash);
    return () => { window.removeEventListener('bilt-section-open', reveal); window.removeEventListener('hashchange', onHash); };
  }, []);
  return <div ref={rootRef} id={id} className="mobile-build-disclosure scroll-mt-24">
    <button type="button" className="mobile-build-disclosure__toggle md:hidden" aria-expanded={open}
      aria-controls={panelId} onClick={() => setOpen(value => !value)}>
      {icon && <span aria-hidden="true" className="mobile-build-disclosure__icon">{icon}</span>}
      <span className="min-w-0 flex-1"><span className="block font-medium text-white">{label}</span>
        {summary && <span className="block text-xs text-zinc-400 mt-0.5">{summary}</span>}</span>
      <span aria-hidden="true" className="text-xl text-zinc-400">{open ? '−' : '+'}</span>
    </button>
    <div id={panelId} className={`${open ? 'block' : 'hidden'} md:block`}>{children}</div>
  </div>;
}
